import React, { useMemo } from "react";
import { UserRound, ShieldCheck, Truck } from "lucide-react";
import { getCompanyPortalPath } from "../../../constants/companyRoutes";

export default function ClientWelcome({ user = {} }) {
  const displayName = useMemo(() => {
    const candidates = [user?.name, user?.displayName, user?.username, user?.email?.split("@")[0]];
    return candidates.find(value => typeof value === "string" && value.trim()) || "Operador";
  }, [user]);

  const steps = [
    {
      key: "profile",
      title: "Finaliza tu Perfil",
      benefit: "Sube foto y datos de contacto para generar confianza.",
      icon: UserRound,
      href: "/dashboard?section=perfil"
    },
    {
      key: "verify",
      title: "Verifica tu Empresa",
      benefit: "Carga documentos de cumplimiento (KYC).",
      icon: ShieldCheck,
      href: getCompanyPortalPath(user)
    },
    {
      key: "publish",
      title: "Publica tu Primera Oportunidad",
      benefit: "Comienza a recibir solicitudes de la red.",
      icon: Truck,
      href: "/dashboard/publications?intent=create"
    }
  ];

  return (
    <section className="welcome-page">
      <div className="welcome-page__shell">
        <div className="welcome-card" aria-label="Pasos para activar la cuenta">
          <header className="welcome-card__header">
            <p className="welcome-card__eyebrow">Cuenta profesional · {displayName}</p>
            <h1>¡Bienvenido a Flotte!</h1>
            <p className="welcome-card__subtitle">
              Estos son los 3 pasos para activar tu cuenta profesional.
            </p>
          </header>

          <div className="welcome-checklist" role="list">
            {steps.map(step => {
              const Icon = step.icon;
              const isExternal = step.href?.startsWith("http");
              return (
                <a
                  key={step.key}
                  className="welcome-checklist__item"
                  href={step.href || "#"}
                  role="listitem"
                  aria-label={`${step.title}. ${step.benefit}`}
                  target={isExternal ? "_blank" : undefined}
                  rel={isExternal ? "noreferrer" : undefined}
                >
                  <div className="welcome-checklist__icon">
                    <Icon size={22} strokeWidth={1.8} />
                  </div>
                  <div className="welcome-checklist__body">
                    <span className="welcome-checklist__title">{step.title}</span>
                    <p className="welcome-checklist__benefit">{step.benefit}</p>
                  </div>
                  <span className="welcome-checklist__chevron" aria-hidden="true">
                    →
                  </span>
                </a>
              );
            })}
          </div>

          <a className="welcome-card__cta" href="/dashboard">
            Empezar Ahora
          </a>
        </div>
      </div>
    </section>
  );
}
